/**
 * The thumbs up and thumbs down pair used by the feedback dialog and the
 * game-over dialog. They behave like a pair of radio buttons that can also be
 * left unpicked: each is a toggle button, and pressing one releases the other.
 */

import { iconSvg } from './icons';
import type { Reaction } from './submission';

const LABELS: Record<Reaction, string> = { up: 'Good', down: 'Not great' };

/**
 * The buttons' markup. With `showLabels` each button reads "Good" or "Not
 * great" next to its thumb; without, the words are only for screen readers.
 */
export function reactionButtonsHTML(showLabels: boolean): string {
  const button = (reaction: Reaction, icon: string): string => `
    <button type="button" class="fb-thumb fb-thumb-${reaction}" data-reaction="${reaction}" aria-pressed="false"${showLabels ? '' : ` aria-label="${LABELS[reaction]}"`}>
      ${icon}${showLabels ? `<span>${LABELS[reaction]}</span>` : ''}
    </button>`;
  return button('up', iconSvg('thumbsUp', 'fb-thumb-icon')) + button('down', iconSvg('thumbsDown', 'fb-thumb-icon'));
}

/** The reaction a pressed button stands for, if the element is one of them. */
export function reactionOf(element: Element): Reaction | undefined {
  const value = element instanceof HTMLButtonElement ? element.dataset.reaction : undefined;
  return value === 'up' || value === 'down' ? value : undefined;
}

/** Shows `reaction` as picked in `group` (or none, for undefined). */
export function showReaction(group: Element, reaction: Reaction | undefined): void {
  group.querySelectorAll<HTMLButtonElement>('.fb-thumb').forEach((button) => {
    button.setAttribute('aria-pressed', String(button.dataset.reaction === reaction));
  });
}
